import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

interface PaginationProps {
    totalItems: number;
    itemsPerPage: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    onPageSizeChange?: (size: number) => void;
    pageSizeOptions?: number[];
    label?: string;
}

const Pagination = ({
    totalItems,
    itemsPerPage,
    currentPage,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = [10, 20, 50, 100],
    label = "items",
}: PaginationProps) => {
    // const totalPages = Math.ceil(totalItems / itemsPerPage);

    // if (totalItems <= itemsPerPage) return null;

    const totalPages = Math.max(
      1,
      Math.ceil(totalItems / itemsPerPage)
    );

    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);


    return (
        <div className="flex flex-col sm:flex-row items-center justify-between px-3 md:px-4 py-3 border-t border-gray-200 gap-3" style={{  backgroundColor: "rgb(227, 242, 253)" }}>
            
            <div className="flex items-center gap-1 text-[10px] md:text-xs text-gray-600">
                {/* PAGE SIZE DROPDOWN OPTIONAL IF NEED*/}
                {onPageSizeChange && (
                    <select
                        value={itemsPerPage}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        className="h-7 md:h-8 px-2 md:px-1 text-[10px] md:text-xs border rounded-md bg-blue-100/50"
                        style={{ borderColor: "#000000" }}
                    >
                        {(pageSizeOptions ?? [10, 20, 50]).map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                )}
                <span className="text-xs md:text-sm text-gray-600 ml-2">
                    Showing {startItem} to {endItem} of {totalItems} {label}
                </span>
            </div>


            <div className="flex items-center gap-1">
                {/* PREVIOUS BUTTON */}
                <Button
                    variant="outline"
                    size="sm"
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                    className="h-7 md:h-8 px-2 md:px-3 text-[10px] md:text-xs"
                    style={{ borderColor: "#000000" }}
                >
                    {/* Previous */}
                    <ChevronLeft className="w-4 h-4" />
                </Button>
                {/* PAGES */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <Button
                        key={page}
                        variant={currentPage === page ? "default" : "outline"}
                        size="sm"
                        onClick={() => onPageChange(page)}
                        className={`h-7 md:h-8 w-7 md:w-8 p-0 text-[10px] md:text-xs ${currentPage === page
                            ? "bg-[#5B9BD5] text-white hover:bg-[#4A8AC5]"
                            : ""
                            }`}
                    >
                        {page}
                    </Button>
                ))}
                {/* NEXT BUTTON */}
                <Button
                    variant="outline"
                    size="sm"
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                    className="h-7 md:h-8 px-2 md:px-3 text-[10px] md:text-xs"
                    style={{ border: "1px solid #000000" }}
                >
                    {/* Next */}
                    <ChevronRight className="w-4 h-4" />
                </Button>
            </div>
        </div>
    );
};

export default Pagination;
